module.exports = __webpack_public_path__ + "img/img-6.4cce1551.png";